import React, { useEffect } from "react";

import { API_URI } from "../config";

//REDUX
import { useSelector, useDispatch } from "react-redux";
import { setPointsAction } from "../redux/actions/userActions";

//COMPONENT
import FlipCounter from "../components/FlipCounter/FlipCounter";

//#region CSS
import { makeStyles } from "@material-ui/core/styles";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
// eslint-disable-next-line
// import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

import { GETDATA } from "../constants";

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: "30px",
    marginBottom: "30px",
    height: "80%"
  },
  text: {
    padding: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      textAlign: "center"
    },
    [theme.breakpoints.up("md")]: {
      textAlign: "start"
    }
  },
  image: {
    [theme.breakpoints.down("sm")]: {
      height: "350px"
    },
    [theme.breakpoints.up("md")]: {
      height: "400px"
    }
  }
}));
//#endregion

function Home(props) {
  const classes = useStyles();

  //#region DISPATCH & SELECTOR
  const dispatch = useDispatch();
  const user = useSelector(state => state.user.user);
  //#endregion

  //#region OnClick
  /*const onClickImage = () => {
    window.open(`${API_URI}/clientes/${user.id}/card/${user.dni}/ilusiona`, "download");
  };*/
  
  const onClickCW = () => {
    let url = `/Clientes/${user.id}/CW`;
    GETDATA(url, response => {
      //window.open(response.data);
      const link = document.createElement('a');
      link.href = response.data;
      //link.target = "_blank"; // Abre en una nueva pestaña
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // Remueve el enlace una vez hecho el clic
    }, error => {
      // reject(error);
    });
  };

  //#endregion

  useEffect(() => {
    const setPoints = userId => dispatch(setPointsAction(userId));
    setPoints(user.id);

    //Move camera top
    const comp = document.querySelector("#root").offsetTop - 100;
    window.scroll({ behavior: "smooth", top: comp });
  }, [dispatch, user.id]);


  return (
    <div className={classes.root}>
      <Grid 
        container 
        // spacing={2} 
        justify="center" 
        alignItems="center"
      >
        <Fade in={true} timeout={1000}>
          <Grid
            container
            spacing={2}
            justify="flex-start"
            alignItems="center"
            item
            xs={11}
          >
            <Grid item xs={12}>
              <Box className={classes.text}>
                <Typography color="primary" variant="h4" data-lang="home_welcome_title">
                  BIENVENIDO A ILUSIONA CLUB
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box className={classes.text}>
                <Typography color="secondary" variant="h5" data-lang="home_welcome_subtitle">
                  Acumula puntos y suma ventajas con nuestra tarjeta de
                  fidelización.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={11}>
              <Box className={classes.text}>
                <p data-lang-html="home_points_balance" data-lang-vars={JSON.stringify({name: user.name})}>
                  Hola <strong>{user.name}</strong> actualmente dispones de:
                </p>
              </Box>
            </Grid>
            <Grid container justify="center" alignItems="center" item xs={12}>
              <Grid item xs={11} md={5} lg={3} xl={2}>
                <FlipCounter since={user.points > 999999 ? 999999 : user.points} />
              </Grid>
            </Grid>

            {/* { user.email.includes("@ilusiona.com") ?
              <Grid item xs={12}>
                <Box textAlign="center">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={onClickCW}
                  >
                    Captain Wallet
                  </Button>
                </Box>
              </Grid>
              :
              ''
            } */}

            { user.email.includes("@ilusiona.com") || true ?
            <Grid container justify="center" alignItems="center" item xs={12}>
              <Box xs={11} md={5} lg={3} xl={2}>
                <img
                  id="banner-cw"
                  alt="Banner Wallet"
                  src={`${process.env.PUBLIC_URL}/assets/img/walletizate_ilusiona_banner.png`}
                  title="Banner Wallet"
                  width="400px"
                  height="680px"
                  useMap="#workmap" 
                  onClick={onClickCW}
                  style={{ cursor: "pointer" }}
                />
                {/*<map name="workmap"><area shape="rect" coords="455,34,566,113" alt="wallet" href="#1" onClick={onClickCW}/></map>*/}
              </Box>
            </Grid>
              :
              ''
            }

            <Grid item xs={12}>
              <Box className={classes.text}>
                <label align="justify" data-lang-html="home_desc_intro">
                  Para mejorar tu experiencia hemos creado el{" "}
                  <strong>ILUSIONA CLUB</strong>. Con él podrás acumular puntos
                  y canjearlos por todos los regalos que puedas imaginar, además
                  de estar informado de todas nuestras promociones y novedades.
                </label>
                <label align="justify" data-lang-html="home_desc_how">
                  ¿Cómo conseguir tus puntos Ilusiona? Muy fácil, acude a
                  cualquiera de nuestros centros y realiza la actividad que más
                  te guste: márcate un strike a los bolos, consigue asombrar a
                  tus amigos con tus habilidades en la zona de game y
                  redemption, sopla las velas en nuestra zona de cumpleaños,
                  ¡descúbrenos y empieza a sumar!
                </label>
                <label align="justify" data-lang-html="home_desc_gifts">
                  Recuerda, en nuestras vitrinas encontrarás una amplia gama de
                  regalos, pero si quieres uno y no lo ves …. ¡No te preocupes
                  nosotros te lo conseguimos!, sólo tienes que pedírnoslo
                  ilusionad@.
                </label>
                <label align="justify" data-lang-html="home_desc_bowling">
                  ¿Sabías que puedes canjear puntos Ilusiona por partidas de
                  Bolos? ¡Tus partidas de bolos pueden salirte gratis! Además
                  recuerda que puedes acumular tus puntos en nuestra tarjeta de
                  fidelización, donde te resultará más sencillo guardar todos
                  los puntos, y tendrás promociones especiales como miembro de
                  nuestro ILUSIONA CLUB!!!.
                </label>
                <label align="justify" data-lang-html="home_desc_contact">
                  Estaremos encantados de contestar a cualquier pregunta o
                  sugerencia que tengas sobre el Ilusiona Club en{" "}
                  <a
                    href="mailto:ilusiona.club@ilusiona.com"
                    style={{ color: "#DF7D44" }}
                  >
                    ilusiona.club@ilusiona.com
                  </a>
                </label>
              </Box>
            </Grid>
            {/**<Grid item xs={12}>
              <Box textAlign="center">
                <img
                  id="tarjeta_ilusiona"
                  alt="Tarjeta Ilusiona"
                  src={`${API_URI}/clientes/${user.id}/card/${user.dni}/ilusiona`}
                  title="Tarjeta"
                  className={classes.image}
                />
              </Box>
            </Grid>
            {/*<Grid item xs={12}>
              <Box textAlign="center">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={onClickImage}
                >
                  Descargar tarjeta
                </Button>
              </Box>
            </Grid>*/}
          </Grid>
        </Fade>
      </Grid>
    </div>
  );
}

export default Home;
